<template>
  <div>
    <div class="mx-2 pt-2 py-2">
      <h1 class="flex justify-center text-2xl 100vh mb-5 pt-10">
        Update Staff
      </h1>
      <form class="max-w-md mx-auto" @submit.prevent="submit">
        <div class="mb-5">
          <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Name</label>
          <input type="text" v-model="name" id="username"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Hospital Name" />
        </div>
        <div class="mb-5">
          <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Employe Code</label>
          <input type="text" v-model="employee_code" id="username"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Employe Code" />
          <span class="text-red-500 text-sm">{{ errorMessage }}</span>
        </div>
        <div class="mb-5">
          <label for="number" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Code</label>
          <input type="text" max="5" v-model="code" id="username"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Code" />
          <span class="text-red-500 text-sm">{{ errorMessagecode }}</span>
        </div>
        <div class="mb-5">
          <label for="number" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Cnic</label>
          <MaskInput type="text" :value="cnic" v-model="cnic" id="username" mask="#####-#######-#"
            style="outline: aliceblue"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="XXXXX-XXXXXXX-X" />
        </div>
        <div class="mb-5">
          <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Father Name</label>
          <input type="text" v-model="father_name" id="displayname"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Father Name" />
        </div>
        <div class="mb-5">
          <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Age</label>
          <input type="text" v-model="age" id="displayname"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="age" />
        </div>
        <div class="mb-5">
          <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Phone</label>
          <MaskInput type="text" mask="+92 (###) ####-###" placeholder="+92 (XXX) XXXX-XXX" v-model="Phone" :value="Phone"
            id="displayname"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" />
        </div>
        <div class="mb-5">
          <label for="text" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Address</label>
          <input type="text" v-model="address" id="displayname"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="Address" />
        </div>
        <div class="mb-5">
          <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Hospital</label>
          <select id="hospitals" ref="staffHospital" multiple v-model="hospital_id" placeholder="City"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option>Choose a Hospital</option>
            <option v-for="site in selectHospitals" :key="site.id" :value="site.id">
              {{ site.name }}
            </option>
          </select>
        </div>
        <div class="mb-5">
          <label for="countries" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Staff
            Type</label>
          <select id="Site_Type" v-model="staff_type_id"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option disabled selected value="">Choose a site type</option>
            <option v-for="site in selectstaff" :key="site.id" :value="site.id">
              {{ site.type }}
            </option>
          </select>
        </div>
        <div class="mb-5">
          <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Email</label>
          <input type="email" id="email" v-model="email"
            class="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            placeholder="name@flowbite.com" />
        </div>
        <div class="flex items-center">
          <label class="relative flex items-center mb-5 cursor-pointer">
            <input type="checkbox" v-model="is_active" value="" class="sr-only peer" />
            <div
              class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600">
            </div>
            <span class="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Active</span>
          </label>
        </div>
        <div class="flex items-center justify-center">
          <router-link to="Staff"
            class="text-white mb-5 bg-button-blue focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            Back</router-link>
          <button type="submit" :disabled="isdisabled" :class="{ 'bg-gray-500 ': isdisabled }"
            class="text-white mb-5 ml-5 bg-bg-save focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            Update Staff
          </button>
        </div>
      </form>
    </div>
  </div>
</template>


<script setup>
import $ from "jquery";
import "select2";
import { ref, watch, computed, onMounted, onUnmounted } from "vue";
import axiosInstce from "@/plugins/axios";
import { useRouter } from "vue-router"; // Import the useRouter function from vue-router
const router = useRouter();
const Hospital = ref([]);
const selectstaff = ref([]);
const name = ref();
const email = ref();
const employee_code = ref();
const is_active = ref();
const hospital_id = ref([]);
const staffId = ref();
const code = ref();
const Phone = ref();
const address = ref();
const cnic = ref();
const father_name = ref();
const age = ref();
const staff_type_id = ref();
const selectHospitals = ref([]);
import Swal from "sweetalert2";
const codeValidationError = ref("");
const emplyeValidationError = ref("");
import { MaskInput } from "vue-3-mask";

const isdisabled = ref(false);
const errorMessagecode = ref("");
const errorMessage = ref("");

watch(employee_code, (newValue) => {
  // Check if the value is a number
  if (isNaN(newValue)) {
    errorMessage.value = "Invalid input. Please enter a number.";
    isdisabled.value = true;
  } else {
    const codeString = String(newValue);
    if (/^\d{5}$/.test(codeString)) {
      // Valid 5-digit number
      errorMessage.value = "";
      isdisabled.value = false;
    } else {
      // Invalid input or not a 5-digit number
      errorMessage.value = "Code must be a 5-digit number.";
      isdisabled.value = true;
    }
  }
});
watch(code, (newValue) => {
  // Check if the value is a number
  if (isNaN(newValue)) {
    errorMessagecode.value = "Invalid input. Please enter a number.";
    isdisabled.value = true;
  } else {
    const codeString = String(newValue);
    if (/^\d{5}$/.test(codeString)) {
      // Valid 5-digit number
      errorMessagecode.value = "";
      isdisabled.value = false;
    } else {
      // Invalid input or not a 5-digit number
      errorMessagecode.value = "Code must be a 5-digit number.";
      isdisabled.value = true;
    }
  }
});
const getstaff = () => {
  axiosInstce
    .get(`/staff/${staffId.value}`)
    .then((response) => {
      const shifts = response.data.data.staff;
      shifts.value = shifts;
      (code.value = shifts?.code),
        (father_name.value = shifts?.father_name),
        (name.value = shifts?.name),
        (employee_code.value = shifts?.employee_code),
        (email.value = shifts?.email),
        (cnic.value = shifts?.cnic),
        (Phone.value = shifts?.phone),
        (email.value = shifts?.email);
      (age.value = shifts.age),
        (is_active.value = shifts.is_active),
        (staff_type_id.value = shifts?.staff_type?.id),
        (hospital_id.value = shifts?.hospital?.id),
        (address.value = shifts?.address);
      const hospitalIdsArray = Array.isArray(shifts)
        ? shifts.map((shift) => shift?.hospital?.id)
        : [shifts?.hospital?.id];
      (hospital_id.value = hospitalIdsArray),

        console.log(hospitalIdsArray);
      // console.log(shifts, 'ssssssssssssssssssssssss');
    })
    .catch((error) => {
      console.error("Error fetching sites:", error);
    });
};
const getHospital = () => {
  const hospitalId = 100000000;
  axiosInstce
    .get(`/hospitals/${hospitalId}`)
    .then((response) => {
      const hospital = response.data.data.data;
      const districtNames = hospital.map((hospitals) => hospitals);
      // selectstaff.value = districtNames;
      selectHospitals.value = districtNames;
    })
    .catch((error) => {
      console.error("Error fetching hospitals:", error);
    });
};
const getstaffid = () => {
  axiosInstce
    .get(`staff-types-paginate/100`)
    .then((response) => {
      const site = response.data.data.data;
      const siteNames = site.map((sites) => sites);
      selectstaff.value = siteNames;
    })
    .catch((error) => {
      console.error("Error fetching sites:", error);
    });
};
const submit = async () => {
  try {
    const selectedHospitals = $("#hospitals").val();
    if (selectedHospitals && selectedHospitals.length > 1) {
      // Show a warning message
      Swal.fire({
        title: "Warning",
        text: "Please select only one hospital.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return; // Stop further execution
    }
    const response = await axiosInstce.put(`/staffs/${staffId.value}`, {
      name: name.value,
      address: address.value,
      email: email.value,
      is_active: is_active.value ? 1 : 0,
      phone: Phone.value,
      code: code.value,
      father_name: father_name.value,
      cnic: cnic.value,
      employee_code: employee_code.value,
      staff_type_id: staff_type_id.value,
      hospital_id: selectedHospitals[0],
      age: age.value,
    });
    Swal.fire({
      toast: true,
      title: "staff Update successfully.",
      icon: "success",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
    router.push({ name: "Staff" });
  } catch (error) {
    console.error("Error fetching Staff info:", error);
    Swal.fire({
      toast: true,
      title: error.response.data.message,
      icon: "error",
      position: "top-end",
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  }
  // form.value = '';
};
import { useAuthService } from "@/store/Auth"; //  auth.js file
const authStore = useAuthService();
const permissions = ref([]);
onMounted(() => {
  const authData = authStore.authData;
  permissions.value = authStore.authData.permissions;
});
const hasCanSignSiteToUser = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can assign site to user"
  )
);
const hascanassignroletouser = computed(() =>
  permissions.value.some(
    (permission) => permission.name === "can assign role to user"
  )
);
$(document).ready(function () {
  // Initialize Select2 for Select 1
  $("#hospitals").select2({
    placeholder: "Select Hospital",
    allowClear: true,
  });
});
onMounted(async () => {
  const id = router.currentRoute.value.params.id;
  staffId.value = id;
  getstaff();
  getHospital();
  getstaffid();
});
onMounted(async () => {
  await authStore.handlepermission();
});

onUnmounted(async () => {
  await authStore.handlepermission();
});
</script>

<style></style>